export default __webpack_public_path__ + "v1.18.25/static/media/libreView-small-ar.49a1f8b1.svg";